import { useSelector } from 'react-redux';
import { documentTranslationsFeatureSelector } from '../../../pricing/selectors';

export const useTranslationEnabled = () => {
  const isTranslationEnabled = useSelector(documentTranslationsFeatureSelector);

  return isTranslationEnabled;
};
